<template>
			<div id="content">
        <div id="common">
          <h1 class="widhlead">商品紹介</h1><br>
					<!-- h2 class="large">特集から探す</h2>
					<ul class="list_special">
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: '新入荷'}}"><img src="/images/special01.jpg"><label>新入荷商品</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: 'おすすめ'}}"><img src="/images/special02.jpg"><label>おすすめ商品</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: '災害'}}"><img src="/images/special03.jpg"><label>災害支援商品</label></router-link>
          </li>
          </ul -->

					<h2><i class="fas fa-search"></i>機種一覧から探す</h2>
					<ul class="list_category">
						<li>
              <router-link :to="{ name: 'speclist2', params: { Spec: '荷役'}}">
								<img src="/images/catalog/category01.jpg">
								<label>荷役・揚重機械</label>
							</router-link>
						</li>
						<li>
              <router-link :to="{ name: 'speclist2', params: { Spec: '自走式高所'}}">
								<img src="/images/catalog/category02.jpg">
								<label>自走式高所作業車</label>
							</router-link>
						</li>
						<li>
              <router-link :to="{ name: 'speclist2', params: { Spec: 'トラック式高所'}}">
								<img src="/images/catalog/category03.jpg">
								<label>トラック式高所作業車</label>
							</router-link>
						</li>
						<li>
              <router-link :to="{ name: 'speclist2', params: { Spec: '掘削機械'}}">
								<img src="/images/catalog/category04.jpg">
								<label>掘削機械</label>
							</router-link>
						</li>
						<li>
              <router-link :to="{ name: 'speclist2', params: { Spec: '運搬・整地機械'}}">
								<img src="/images/catalog/category05.jpg">
								<label>運搬・整地機械</label>
							</router-link>
						</li>
						<li>
              <router-link :to="{ name: 'speclist2', params: { Spec: 'レンタカー・搭乗式'}}">
								<img src="/images/catalog/category06.jpg">
								<label>レンタカー・搭乗式掃除機</label>
							</router-link>
						</li>
          </ul>
          <ul class="list_category2">
						<li>
              <router-link :to="{ name: 'speclist2', params: { Spec: '発電機・コンプレッサー'}}">
								<img src="/images/catalog/category07.jpg">
								<label>発電機・コンプレッサー</label>
							</router-link>
						</li>
						<li>
              <router-link :to="{ name: 'speclist2', params: { Spec: '販売品'}}">
								<img src="/images/catalog/category08.jpg">
								<label>販売品</label>
							</router-link>
						</li>
          </ul>  
					<h2 class="large">参考資料</h2>
					<ul class="list_document">
						<li>
							<a href="/../document/article.html">
								<label>レンタル約款</label>
							</a>
						</li>
						<li>
							<a href="/../pdf/article-rental-support201807.pdf" target="_blank">
								<label>レンタル物件サポート特約制度</label>
							</a>
						</li>
						<li>
							<a href="/../document/special-contract.html">
								<label>レンタル保険制度</label>
							</a>
						</li>
						<li>
							<a href="/document/law.html">
								<label>法規</label>
							</a>
						</li>
						<li>
							<a href="/../document/qualification.html">
								<label>資格</label>
							</a>
						</li>
						<li>
							<a href="/../document/unit.html">
								<label>単位</label>
							</a>
						</li>
						<li>
							<a href="/../document/guide.html">
								<label>ご利用ガイド</label>
							</a>
						</li>
					</ul>
      </div>
    </div>
</template>

<script>
  export default {
    data: function () {
      return {
      }
    },
    mounted: function (){
      this.$parent.category_id = null
    },
    methods: {
    },
    watch: {
    }
  }
</script>
